// extracted by mini-css-extract-plugin
export default {"root":"home8_root__1q7iS"};